import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetStep } from '../../store/reducers/flowStepReducer';
import { OtpVerify } from '../../store/reducers/otpReducer';


import './OtpScreen.css';

const OtpScreen = ({ mobile, onSubmit }) => {

  const dispatch = useDispatch();
  const { apiResponse } = useSelector((state) => state.OtpAuthenticateList);

  const [otp, setOtp] = useState(['', '', '', '']);
  const [timer, setTimer] = useState(60); // countdown in seconds
  const navigate = useNavigate();

  useEffect(() => {

    // dispatch(OtpVerify());

    const countdown = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(countdown);
  }, []);

  const handleChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      // Auto-focus next input
      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };


const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };
  

  const handleSubmit = () => {
    const fullOtp = otp.join('');
    if (fullOtp.length === 4) {
      const requestData = {mobile_number:mobile,verification_code:fullOtp}
      onSubmit(requestData);
    }
  };


const handleClose = () => {
    dispatch(resetStep());// Reset Redux state
    // window.history.back(); // or use navigate(-1) if using React Router
    // navigate(-1);
    navigate('/customer-profile'); 
  };


  return (
    <div className="otp-screen">
        <div className="otp-header">
        <button className="close-button" 
        onClick={handleClose}
        //  onClick={() => navigate(-1)}
         >
          &times;
        </button>

        </div>
      <h2>OTP Verification</h2>
      
  {/* <div className="mobile-field">
    <label htmlFor="mobile">Mobile Number</label>
    <input
      type="text"
      id="mobile"
      value={mobile}
      readOnly
      className="mobile-input"
    />
  </div> */}

  <p>OTP sent to <strong>{mobile}</strong></p>


      <div className="otp-inputs">
        {otp.map((digit, index) => (
          <input
            key={index}
            id={`otp-${index}`}
            type="text"
            maxLength="1"
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            className="otp-box"
          />
        ))}
      </div>

      <div className="otp-timer">
        {timer > 0 ? `00:${timer.toString().padStart(2, '0')}` : 'Resend OTP'}
      </div>

      <button className="verify-btn" onClick={handleSubmit} disabled={otp.join('').length !== 4}>
        Verify
      </button>

      {/* <button className="signup-btn">Sign Up</button> */}
    </div>
  );
};

export default OtpScreen;
